import React from 'react'
import styles from './styles.css'
import CheckIcon from 'react-icons/lib/md/check'

export default function CorrectlySaved(props) {
  const {vehicle} = props
  return (
    <div className={styles.container}>
      <div className={styles.logo}>
        <img src="https://orioneat.com/logo-dark.svg" alt="Logo" />
      </div>
      <div className={styles.content}>
        <h2>Hola {vehicle.fullName}!</h2>
        <h3>Tus datos bancarios y de facturación se encuentran guardados</h3>
      </div>

      <div className={styles.containerIcon}>
        <CheckIcon size={45} color="green" />
      </div>
    </div>
  )
}
